import { standardListener } from '../config/vars';
import { triggerEvent } from '../lib/helper';
import { toArray } from 'lodash';

const triggerSelector = '.tc-edit-data-trigger';
const formContentSelector = '.account-form-content';

export default class EditAccountData {

  constructor(el) {

    this.el = el;

    this.isOpen = (this.el.classList.contains('is-active')) ? true : false;
    this.toggleHandler = this.toggle.bind(this);

    this.triggers = toArray(this.el.querySelectorAll(triggerSelector));
    this.content = this.el.querySelector(formContentSelector);
    this.inputs = toArray(this.content.getElementsByTagName('input'));
    this.select = toArray(this.content.getElementsByTagName('select'));
    this.selectWrapper = toArray(this.content.querySelectorAll('.is-selector'));

    this.triggers.map(item => {

      item.addEventListener(standardListener, this.toggleHandler, false);
    });

    const errorInput = this.content.querySelector('.has-errors input,.has-errors select,.has-errors textarea');
    if (errorInput) {

      this.open(false);
      errorInput.focus();
    }
  }

  open(trigger = true) {

    if (this.isOpen) {

      return;
    }

    this.isOpen = true;

    this.el.classList.add('is-active');

    this.inputs.map(item => {

      item.disabled = false;
    });

    this.select.map(item => {

      item.disabled = false;
    });

    this.selectWrapper.map(item => {

      item.classList.remove('is-disabled');
    });

    trigger && this.dispatchEvent('open');
  }

  close(trigger = true) {

    if (!this.isOpen) {

      return;
    }

    this.isOpen = false;

    this.el.classList.remove('is-active');

    this.inputs.map(item => {

      item.disabled = true;
    });

    this.select.map(item => {

      item.disabled = true;
    });

    this.selectWrapper.map(item => {

      item.classList.add('is-disabled');
    });

    trigger && this.dispatchEvent('close');
  }

  toggle(e) {

    e.preventDefault();

    this[this.isOpen ? 'close' : 'open']();
  }

  dispatchEvent(type) {

    triggerEvent(this.el, 'account-form-' + type, {
      collapse: this
    });
  }
};
